import { FC, useContext } from 'react';

import { Spinner } from 'components/Spinner';
import { AddonsContext } from 'contexts/addons';
import { BonusCardSmall } from 'components/BonusCard';

import { ScDepositBonusesSections } from './styled';

export const DepositBonuses: FC = () => {
  const { pendingBonusGroups, pendingBonuses, depositBonuses } = useContext(
    AddonsContext
  );

  return pendingBonuses || pendingBonusGroups ? (
    <Spinner size={64} center />
  ) : depositBonuses.length !== 0 ? (
    <ScDepositBonusesSections>
      {depositBonuses.map(
        ({
          background,
          character,
          offer,
          termsAndConditions,
          code,
          scheduler,
          countdownToggle,
        }) => (
          <BonusCardSmall
            key={code}
            background={background}
            character={character}
            offer={offer}
            termsAndConditions={termsAndConditions}
            code={code}
            scheduler={scheduler}
            countdownToggle={countdownToggle}
          />
        )
      )}
    </ScDepositBonusesSections>
  ) : null;
};
